/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { HwPlansContext } from '../contexts';

export const useHwPlansStore = () => useContext(HwPlansContext);
